module.exports = __webpack_public_path__ + "img/case-logo-17.974eef3e.png";